import QRAPIs from '@/API/qr-api'

const qrDefault = {
  first_fill_color: '#000000',
  second_bg_color: '#ffffff',
  logo: null,
  is_plain: 1,
  type: 'menu',
  value: 'welcome',
}
export default {
  namespaced: true,
  state: {
    dependenciesLoaded: false,
    all_tables_generated: false,
    all_forms_generated: false,
    tables: [],
    forms: [],
    selling_types: [],
    qr_menu: false,
    temp_qr: qrDefault,
    qr_preview: null,
    menu_types: ['welcome'],
    selected_branch_id: null,
    selected_branch: {},
  },
  getters: {
    tempQr: (state: any) => state.temp_qr,
    allTablesGenerated: (state: any) => state.all_tables_generated,
    allFormsGenerated: (state: any) => state.all_forms_generated,
    tables: (state: any) => state.tables,
    forms: (state: any) => state.forms,
    qrMenuEnabled: (state: any) => state.qr_menu,
    qrPreview: (state: any) => state.qr_preview,
    qrSellingTypes: (state: any) => state.selling_types,
    qrMenuTypes: (state: any) => state.menu_types,
    selectedBranchId: (state: any) => state.selected_branch_id,
    selectedBranch: (state: any) => state.selected_branch,
  },
  mutations: {
    SET_SETTINGS(state: any, payload: any) {
      state.all_tables_generated = payload?.all_tables ?? false
      state.all_forms_generated = payload?.all_forms ?? false
      state.tables = payload?.tables ?? []
      state.forms = payload?.forms ?? []
      state.qr_menu = payload?.qr_menu ?? false
      state.selling_types = payload?.selling_types ?? []
      state.dependenciesLoaded = payload.branchId
    },
    SET_TEMP_QR(state: any, payload: any) {
      state.temp_qr.type = payload.type
      state.temp_qr.value = payload.value
    },
    SET_DEFAULT_TEMP_QR(state: any, payload?: any) {
      state.temp_qr = payload ?? qrDefault
    },
    SET_TEMP_SETTING(state: any, payload: any) {
      state.temp_qr = { ...state.temp_qr, ...payload }
    },
    SET_QR_PREVIEW(state: any, payload: any) {
      state.qr_preview = payload
    },
    SET_MENU_TYPES(state: any, payload: any) {
      state.menu_types = payload
    },
    SET_BRANCH(state: any, branch: any) {
      state.selected_branch_id = branch?.id
      state.selected_branch = branch
    },
  },
  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      const branchId = context.getters.selectedBranchId ?? context.rootGetters['branches/currentBranchId']
      if (context.state.dependenciesLoaded === branchId) return
      const res = await QRAPIs.getDependencies(branchId)
      context.commit('SET_SETTINGS', { ...res, branchId })
    },
    async SAVE_QR(context: any) {
      const method = context.state?.temp_qr?.id ? 'update' : 'create'
      const data = { ...context.state.temp_qr }
      // eslint-disable-next-line no-return-await
      return (await QRAPIs[method](data))
    },
    async PREVIEW_QR(context: any) {
      await QRAPIs.previewQR(context.getters.tempQr)
        .then(qr => (context.commit('SET_QR_PREVIEW', qr)))
        .catch(e => console.log(e.message))
    },
  },
}
